export default "__VITE_ASSET__BZyj1Hb5__"